import { TEMPLATE_TYPES } from "features/templates/constants";
import type { CreatedTemplate, TemplateType } from "features/templates/types";

import Skeleton from "common/components/ui/Skeleton";

import TemplatesListItem from "./TemplatesListItem";

import type { JSX } from "react";

export default function TemplatesList({
  isLoading,
  templates,
  templateType,
  hasSearch,
}: {
  isLoading: boolean;
  templates: CreatedTemplate[];
  templateType: TemplateType;
  hasSearch: boolean;
}) {
  const templateTypeLabel =
    TEMPLATE_TYPES[templateType].shortLabel.toLowerCase();

  let mainContent: JSX.Element | JSX.Element[] = (
    <div className="flex flex-col gap-y-0.5 px-6 my-auto">
      <h5 className="text-sm-bold text-center">
        No {templateTypeLabel} templates found
      </h5>
      <p className="text-black-500 text-xs-medium text-center">
        {hasSearch
          ? "There were no results found for your search. Try adjusting your filters or search terms"
          : `You do not have any ${templateTypeLabel} templates. Create one to use it in your campaigns`}
      </p>
    </div>
  );

  if (isLoading) {
    mainContent = new Array(7).fill({}).map((_, index) => (
      <div
        className="flex items-center gap-x-2 border-b border-b-black-200 p-4"
        // biome-ignore lint/suspicious/noArrayIndexKey: no key available
        key={index}
      >
        <Skeleton className="size-10 rounded-2xl" />
        <div className="flex flex-1 flex-col gap-y-0.5">
          <Skeleton className="h-5 w-32" />
          <div className="flex justify-between">
            <Skeleton className="h-4 w-10" />
            <Skeleton className="h-4 w-10" />
            <Skeleton className="h-4 w-10" />
          </div>
        </div>
      </div>
    ));
  } else if (templates.length) {
    mainContent = templates.map((template) => (
      <TemplatesListItem key={template.id} template={template} />
    ));
  }
  return (
    <div className="flex flex-col overflow-y-auto scrollbar-thin flex-1">
      {mainContent}
    </div>
  );
}
